import { Currency } from 'core/payments/entities';

export enum AxonEventNames {
  PAGE_VIEW = 'page_view',
  VIEW_ITEM = 'view_item',
  ADD_TO_CART = 'add_to_cart',
  BEGIN_CHECKOUT = 'begin_checkout',
  PURCHASE = 'purchase',
}

type AxonItem = {
  productId: string;
  price: number;
};

export type AxonViewItemParams = {
  items: Array<AxonItem>;
  currency: Currency;
};

export type AxonAddToCartParams = AxonItem & {
  currency: Currency;
};

export type AxonBeginCheckoutParams = AxonItem & {
  currency: Currency;
};

export type AxonPurchaseParams = AxonItem & {
  currency: Currency;
  paymentId: string;
  email: string;
  nebulaId: string;
};

export type AxonMethods = {
  init: () => void;
  track: (eventName: AxonEventNames, params?: Record<string, unknown>) => void;
};
